import { useTranslation } from "react-i18next";
import { translate as tr } from "../../i18n";
import React, { useState, useEffect, useRef } from "react";
import "../../assets/css/modal.css";
import { useSelector } from "react-redux";
import ColorPicker from "../common/ColorPicker";
import ProjectBillingRateField from "../common/ProjectBillingRateField";
import axios from "axios";
import {Modal} from "react-bootstrap";

const workspaceStyleDisplay = {
    position: "absolute",
    transform: "translate3d(20px, -44px, 0px)",
    top: "0px",
    left: "0px",
    willChange: "transform",
    display: "block",
    minWidth: "25em",
};
const workspaceStyleHide = { display: "none" };

const clientStyleDisplay = {
    position: "absolute",
    transform: "translate3d(20px, -44px, 0px)",
    top: "0px",
    left: "0px",
    willChange: "transform",
    display: "block",
    minWidth: "25em",
};

const clientStyleHide = { display: "none" };

const getClientDisplayName = (client) =>
    client?.company_name || client?.client_name || "";

function ProjectModal({ handleClose, show, reloadList, setProjectInDashBoard,title }) {
  useTranslation();
    const showHideClassName = show ? "modal display-block" : "modal display-none";
    const auth = useSelector((state) => state.auth);
    const [openClient, setClient] = useState(false);
    const [project_name, setProjectName] = useState("");
    const [workspaceData, setWorkspaceData] = useState({ title: "", id: "" });
    const [clientData, setClientData] = useState({ get title() { return tr("No Client"); }, id: "" });
    const [searchTerm, setSearchTerm] = useState("");
    const [openworkspace, setWorkspace] = useState(false);
    const [errors, setErrors] = useState({});
    const [project_color, setColor] = useState("#000000");
    const [workspaceList, setWorkspaceList] = useState([]);
    const [clientList, setClientList] = useState([]);
    const [defaultBillable, setDefaultBillable] = useState(false);
    const [workspaceDefaultRate, setWorkspaceDefaultRate] = useState(null);
    const [workspaceDefaultCurrencyId, setWorkspaceDefaultCurrencyId] = useState(null);
    const [workspaceDefaultCurrencyCode, setWorkspaceDefaultCurrencyCode] = useState("");
    const [currencyLookup, setCurrencyLookup] = useState([]);
    const [overrideHourlyRate, setOverrideHourlyRate] = useState(false);
    const [hourlyRate, setHourlyRate] = useState("");
    const [estimate, setEstimate] = useState("");
    const clientFieldRef = useRef(null);
    const workspaceFieldRef = useRef(null);

    useEffect(() => {
        const handleDocumentClick = (e) => {
          const insideClientField = clientFieldRef.current && clientFieldRef.current.contains(e.target);
          const insideWorkspaceField = workspaceFieldRef.current && workspaceFieldRef.current.contains(e.target);

          if (!insideWorkspaceField) {
            setWorkspace(false);
          }
          if (!insideClientField) {
            setClient(false);
            setSearchTerm("");
          }
        };

        document.addEventListener("click", handleDocumentClick, true);
        getCurrencies();
        getClientList();
        getWorkspaceList();

        return () => document.removeEventListener("click", handleDocumentClick, true);
    }, []);

    useEffect(() => {
        if (show) {
            setProjectName(title || "");
            setOverrideHourlyRate(false);
            setHourlyRate("");
            setErrors({});
        }
    }, [show, title]);

    useEffect(() => {
      if (!workspaceDefaultCurrencyCode && workspaceDefaultCurrencyId && currencyLookup.length > 0) {
        const match = currencyLookup.find((c) => Number(c.id) === Number(workspaceDefaultCurrencyId));
        if (match?.currency) {
          setWorkspaceDefaultCurrencyCode(match.currency);
        }
      }
    }, [currencyLookup, workspaceDefaultCurrencyId, workspaceDefaultCurrencyCode]);

    const resolveWorkspaceCurrencyCode = (currencyId, fallbackCode = "") => {
      if (fallbackCode) return fallbackCode;
      const match = currencyLookup.find((c) => Number(c.id) === Number(currencyId));
      return match?.currency ?? "";
    };

    const workspaceCurrencyCode = workspaceDefaultCurrencyCode || resolveWorkspaceCurrencyCode(workspaceDefaultCurrencyId, "");
    const workspaceRateLabel = workspaceDefaultRate !== null && workspaceDefaultRate !== undefined
      ? `${workspaceCurrencyCode ? `${workspaceCurrencyCode} ` : ""}${workspaceDefaultRate}/hr`
      : "";

    const getCurrencies = async () => {
      try {
        const config = {
          headers: {
            Authorization: `Bearer ${auth.token}`,
            "Content-Type": "application/json",
          },
        };
        const res = await axios.get("/api/team/currencies", config);
        if (res.status === 200) {
          setCurrencyLookup(res.data.currencies ?? []);
        }
      } catch (err) {
        console.log(err);
      }
    };

    const getWorkspaceList = async () => {
        const config = {
          headers: {
            Authorization: `Bearer ${auth.token}`,
            "Content-Type": "application/json",
          },
        };
        let workspace_id = auth.workspace_id;
        const body = JSON.stringify({ workspace_id });
        let res = await axios.post(
          "/api/workspace/listbyworkspaceid",
          body,
          config
        );
        if (res.status === 200) {
          const results = res.data.results;
          // Find the currently active workspace (use Number() to avoid string/number type mismatch)
          const active = results.find((item) => Number(item.id) === Number(workspace_id));
          if (active) {
            setDefaultBillable(active.is_default_billable === 1);
            setWorkspaceData({ title: active.title, id: active.id });
            setWorkspaceDefaultRate(active.default_billable_rate ?? null);
            setWorkspaceDefaultCurrencyId(active.default_currency_id ?? null);
            setWorkspaceDefaultCurrencyCode(resolveWorkspaceCurrencyCode(active.default_currency_id, active.default_currency));
          } else if (results.length > 0) {
            // Fallback: select first workspace
            setDefaultBillable(results[0].is_default_billable === 1);
            setWorkspaceData({ title: results[0].title, id: results[0].id });
            setWorkspaceDefaultRate(results[0].default_billable_rate ?? null);
            setWorkspaceDefaultCurrencyId(results[0].default_currency_id ?? null);
            setWorkspaceDefaultCurrencyCode(resolveWorkspaceCurrencyCode(results[0].default_currency_id, results[0].default_currency));
          }
          setWorkspaceList(results);
        }
    };

    const validateForm = () => {
        let errors = {};
        let formIsValid = true;
        if (project_name === "") {
          formIsValid = false;
          errors["project_name"] = "Please enter the Project name";
        }
        if (overrideHourlyRate) {
          const parsedRate = parseInt(hourlyRate, 10);
          if (hourlyRate === "" || Number.isNaN(parsedRate) || parsedRate < 0) {
            formIsValid = false;
            errors["hourly_rate"] = "Please enter a valid hourly rate";
          }
        }
        setErrors(errors);
        return formIsValid;
    };

    const createProject = async () => {
        try {
          if (validateForm()) {
            const config = {
              headers: {
                Authorization: `Bearer ${auth.token}`,
                "Content-Type": "application/json",
              },
            };
            let workspace_id = workspaceData.id;
            let client_id;
            if (clientData.title === "No Client" && clientData.id === "") {
              client_id = "";
            } else {
              client_id = clientData.id;
            }
            let is_default_billable = 0;
            if(defaultBillable === true) {
              is_default_billable = 1;
            }
            const parsedHourlyRate = parseInt(hourlyRate, 10);
            const estimateVal = parseFloat(estimate);
            const body = JSON.stringify({
              project_name,
              workspace_id,
              client_id,
              project_color,
              is_default_billable,
              hourly_rate: overrideHourlyRate ? parsedHourlyRate : null,
              currency_id: overrideHourlyRate ? workspaceDefaultCurrencyId : null,
              estimate: (!isNaN(estimateVal) && estimateVal > 0) ? estimateVal : null,
            });
            let res = await axios.post("/api/project/add", body, config);
            if (res.status === 200) {
              let item = {
                client_name: clientData.id !== null &&
                              clientData.id !== undefined &&
                              clientData.id !== ""?clientData.title:"",
                client_id: clientData.id,
                project_name: project_name,
                id: res.data.results.id,
                workspace_id : workspace_id
              }

              setSearchTerm("");
              setProjectName("");
              setEstimate("");
              setOverrideHourlyRate(false);
              setHourlyRate("");
              setClientData({ get title() { return tr("No Client"); }, id: "" });
              await reloadList(item);
              handleClose();
              //setProjectInDashBoard(item);
            }
          }
        } catch (err) {
          console.log(err);
          if (err.response) {
            console.log(err.response);
          }
        }
    };

    const handleClient = (item) => {
        setClientData({ title: getClientDisplayName(item), id: item.id });
        setClient(false);
    };

    const handleSearchTerm = (e) => {
        setSearchTerm(e.target.value);
    };
    const getClientList = async (wid) => {
        try {
          const config = {
            headers: {
              Authorization: `Bearer ${auth.token}`,
              "Content-Type": "application/json",
            },
          };
          let workspace_id = wid !== null &&
          wid !== undefined? wid : auth.workspace_id;
          const body = JSON.stringify({ workspace_id, searchTerm });
          //console.log(body)
          let res = await axios.post("/api/client/search", body, config);
          if (res.status === 200) {
            //console.log(res.data.results)
            setClientList(res.data.results);
          }
        } catch (err) {
          console.log(err);
          if (err.response) {
            console.log(err.response);
          }
        }
    };

    const handleNoClient = () => {
        setClientData({ get title() { return tr("No Client"); }, id: "" });
        setClient(false);
    };

    const handleWorkspace = (item) => {
        handleNoClient();
        setWorkspaceData({ title: item.title, id: item.id });
        setWorkspaceDefaultRate(item.default_billable_rate ?? null);
        setWorkspaceDefaultCurrencyId(item.default_currency_id ?? null);
        setWorkspaceDefaultCurrencyCode(resolveWorkspaceCurrencyCode(item.default_currency_id, item.default_currency));
        setWorkspace(false);
        getClientList(item.id);
    };

    const handleProjectName = (e) => {
        setProjectName(e.target.value);
    };

    const handleColor = (color) => {
        setColor(color);
    };

    return (
    <>
    <Modal
        show={show}
        onHide={handleClose}
        dialogClassName='add-New-tag-popup-box-container'
        centered
      >
        {/* ── Header ── */}
        <div className='pm-header'>
          <h3 className='pm-title'>{tr("New Project")}</h3>
          <button className='pm-close' onClick={handleClose} aria-label={tr("Close")}>
            <svg width='14' height='14' viewBox='0 0 14 14' fill='none'>
              <path d='M1 1l12 12M13 1L1 13' stroke='currentColor' strokeWidth='2' strokeLinecap='round'/>
            </svg>
          </button>
        </div>

        {/* ── Body ── */}
        <div className='pm-body'>

          {/* Project Name */}
          <div className='pm-field'>
            <label className='pm-label'>{tr("Project Name")}</label>
            <input
              className='pm-input'
              type='text'
              placeholder={tr("e.g. Website Redesign")}
              onChange={handleProjectName}
              value={project_name}
            />
            {errors.project_name && (
              <span className='pm-error'>{errors.project_name}</span>
            )}
          </div>

          {/* Color */}
          <div className='pm-field'>
            <label className='pm-label'>{tr("Color")}</label>
            <ColorPicker
              onSelectColor={(color) => handleColor(color)}
              dbColor={project_color}
            />
          </div>

          <ProjectBillingRateField
            enabled={overrideHourlyRate}
            onToggle={() => {
              setOverrideHourlyRate((current) => {
                const next = !current;
                if (next && !hourlyRate) {
                  setHourlyRate(String(workspaceDefaultRate ?? ""));
                }
                return next;
              });
            }}
            rate={hourlyRate}
            onRateChange={(value) => setHourlyRate(value)}
            currencyLabel={workspaceCurrencyCode}
            workspaceRateLabel={workspaceRateLabel}
            error={errors.hourly_rate}
            warning="This override applies to future entries only. Existing tracked time is not rewritten."
            note={tr("Currency is taken from Workspace Settings > Rates & Currency.")}
          />

          {/* Workspace — only shown when the user has multiple workspaces */}
          {workspaceList.length > 1 && (
            <div ref={workspaceFieldRef} className='pm-field' style={{ position: 'relative' }}>
              <label className='pm-label'>{tr("Workspace")}</label>
              <div
                className='pm-select'
                onClick={() => setWorkspace(!openworkspace)}
              >
                <span className='pm-select-value'>{workspaceData.title}</span>
                <i className={`fa fa-chevron-${openworkspace ? 'up' : 'down'} pm-select-icon`}></i>
              </div>
              {openworkspace && (
                <div className='pm-dropdown'>
                  <ul className='pm-dropdown-list'>
                    {workspaceList.map((item, index) => (
                      <li
                        key={index}
                        className={`pm-dropdown-item${Number(item.id) === Number(workspaceData.id) ? ' pm-dropdown-item--active' : ''}`}
                        onClick={() => handleWorkspace(item)}
                      >
                        {item.title}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          )}

          {/* Client */}
          <div ref={clientFieldRef} className='pm-field' style={{ position: 'relative' }}>
            <label className='pm-label'>{tr("Client")}</label>
            <div
              className='pm-select'
              onClick={() => setClient(!openClient)}
            >
              <span className='pm-select-value'>{clientData.title}</span>
              <i className={`fa fa-chevron-${openClient ? 'up' : 'down'} pm-select-icon`}></i>
            </div>
            {openClient && (
              <div className='pm-dropdown'>
                <div className='pm-dropdown-search'>
                  <input
                    className='pm-dropdown-search-input'
                    type='text'
                    placeholder={tr("Search clients...")}
                    value={searchTerm}
                    onChange={handleSearchTerm}
                    onKeyUp={() => getClientList()}
                  />
                </div>
                <ul className='pm-dropdown-list'>
                  <li className='pm-dropdown-item' onClick={() => handleNoClient()}>{tr("No Client")} </li>
                  {clientList.map((item, index) => (
                    <li
                      key={index}
                      className='pm-dropdown-item'
                      onClick={() => handleClient(item)}
                    >
                      {getClientDisplayName(item)}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>

          {/* Budget */}
          <div className='pm-field'>
            <label className='pm-label'>Budget <span className='pm-label-hint'>{tr("(hours)")}</span></label>
            <input
              className='pm-input'
              type='number'
              min='0'
              step='0.5'
              placeholder={tr("e.g. 40")}
              value={estimate}
              onChange={e => setEstimate(e.target.value)}
            />
          </div>

        </div>

        {/* ── Footer ── */}
        <div className='pm-footer'>
          <button className='pm-btn-cancel' onClick={handleClose}>{tr("Cancel")}</button>
          <button className='pm-btn-create' onClick={() => createProject()}>{tr("Create Project")}</button>
        </div>

      </Modal>
    </>
  );
}
export default ProjectModal;
